import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import CartItemDvdIcon from './CartItemDvdIcon';
import CartItem from './CartItem';
import { DvdMsg } from '../../messages';

function CartLineItemDvd(props) {
  const { lineItem, ...other } = props;

  return (
    <CartItem
      icon={
        <div className="cart-item-icon-container">
          <CartItemDvdIcon />
        </div>
      }
      hasHelpIcon={true}
      lineItem={lineItem}
      title={<DvdMsg />}
      {...other}
    />
  );
}

CartLineItemDvd.propTypes = {
  lineItem: PropTypes.object,
};

export default CartLineItemDvd;
